export default {
  name: 'Pagination',
  components: {},
  props: ['total', 'items', 'reset', 'max'],
  watch: {
    reset(newValue, oldValue) {
      if (newValue === true) {
        this.currentPage = 1;
        this.updateParent();
      }
    }
  },
  data() {
    return {
      currentPage: 1
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.total / this.items);
    },
    prevClass() {
      return this.currentPage === 1 ? 'btn disabled' : 'btn';
    },
    prevDisabled() {
      return this.currentPage === 1;
    },
    nextClass() {
      return this.currentPage === this.totalPages ? 'btn disabled' : 'btn';
    },
    nextDisabled() {
      return this.currentPage === this.totalPages;
    }
  },
  mounted() {},
  methods: {
    setCurrent(page) {
      this.currentPage = page;
      this.updateParent();
    },
    setFirst() {
      this.currentPage = 1;
      this.updateParent();
    },
    setLast() {
      this.currentPage = this.totalPages;
      this.updateParent();
    },
    setNext() {
      this.currentPage++;
      this.updateParent();
    },
    setPrev() {
      this.currentPage--;
      this.updateParent();
    },
    updateParent() {
      this.$emit('setPage', this.currentPage);
    }
  }
};
